import Action from 'actions';
import BaseExecutor from 'services/sports/default/base-executor';
import PlayersQuantityValidator from 'components/organisms/random-team-stacking/validators/players-quantity-validator';
import MinTeamsCheckedValidator from 'components/organisms/random-team-stacking/validators/min-teams-checked-validator';
import MaxSimilarDisallowedPositionsValidator from 'components/organisms/random-team-stacking/validators/max-similar-disallowed-positions-validator';
import MaxDisallowedPositionsInOneGroupValidator from 'components/organisms/random-team-stacking/validators/max-disallowed-positions-in-one-group-validator';
import BaseValidator from 'services/validations/base-validator';

class RandomTeamStackingValidatorBuilder extends BaseExecutor {
    getInterface() {
        const {randomTeamStacking: stacking, sportConfig} = Action.getState();

        if (!stacking.isEnabled()) {
            return new BaseValidator();
        }

        const playersQuantityValidator = new PlayersQuantityValidator();
        playersQuantityValidator.setDependencies({
            stacking,
            sportConfig,
        });

        const minTeamsCheckedValidator = new MinTeamsCheckedValidator();
        minTeamsCheckedValidator.setDependencies({stacking});

        const maxSimilarDisallowedPositionsValidator = new MaxSimilarDisallowedPositionsValidator();
        maxSimilarDisallowedPositionsValidator.setDependencies({
            stacking,
            sportConfig,
        });

        const maxDisallowedPositionsInOneGroupValidator = new MaxDisallowedPositionsInOneGroupValidator();
        maxDisallowedPositionsInOneGroupValidator.setDependencies({
            stacking,
            sportConfig,
        });

        playersQuantityValidator.addSubValidators([
            minTeamsCheckedValidator,
            maxSimilarDisallowedPositionsValidator,
            maxDisallowedPositionsInOneGroupValidator,
        ]);

        return playersQuantityValidator;
    }
}

export {RandomTeamStackingValidatorBuilder};
